export enum EOrderConfirmationType {
    CUSTOMER = 'customer',
    DEALER = 'dealer'
}
